// extracted by mini-css-extract-plugin
export default {"mobileBreakpoint":"1020px","tabletBreakpoint":"1020px","globalNavHeight":"60px"};